<template>
	<inertia-head title="Platinum Connect" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Platinum Connect</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Connect with your fellow Platinum Members
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">
		<div class="row">
			<div class="col-lg-6">
				<div class="block block-rounded shadow">
					<div class="block-content block-content-full border-bottom">
						<h4 class="mb-1">Marcelo Apidos</h4>
						<p class="mb-1 fs-sm text-muted">
							mpapharmacare@gmail.com | 09178619833
						</p>
						<p class="mb-1 fs-sm text-muted">Region II – Cagayan Valley</p>
					</div>
					<div class="block-content bg-body-light">
						<h6 class="mb-1">MPA Pharmacare</h6>
						<p>
							<span class="badge bg-info">mpapharmacare@gmail.com</span>
						</p>
						<p class="fs-sm text-muted">
							Distributor for Medical Supplies, Medical Equipment, Laboratory
							and Dental Supplies.
						</p>
					</div>
				</div>
				<div class="block block-rounded shadow">
					<div class="block-content block-content-full border-bottom">
						<h4 class="mb-1">Reggie Isada-Bundang</h4>
						<p class="mb-1 fs-sm text-muted">
							reg1dabundang@gmail.com | 09189226301
						</p>
						<p class="mb-1 fs-sm text-muted">NCR – National Capital Region</p>
					</div>
					<div class="block-content bg-body-light border-bottom">
						<h6 class="mb-1">Redwood Internet Business, Inc.</h6>
						<p class="space-x-1">
							<span class="badge bg-info">ribundang@regaloservice.com</span>
							<span class="badge bg-info">www.redwoodinternetbiz.com</span>
							<span class="badge bg-info">www.regaloservice.com</span>
							<span class="badge bg-info">www.pinoypartyfood.com</span>
						</p>
						<p class="fs-sm text-muted">
							RiB, Inc owns and operates its own E-commerce stores, and it also
							offers e-Commerce Operations Outsourcing for companies who would
							like to outsource their e-commerce operations.
						</p>
					</div>
					<div class="block-content bg-body-light">
						<h6 class="mb-1">Life Growth Map Seminars</h6>
						<p class="space-x-1">
							<span class="badge bg-info">lgmseminars@gmail.com</span>
						</p>
						<p class="fs-sm text-muted">
							Life Growth Map Seminars (LGMS) is a company that provides quality
							online training and seminars for companies, professionals, and
							individuals. LGMS also offers online event organizing services.
						</p>
					</div>
				</div>
				<div class="block block-rounded shadow">
					<div class="block-content block-content-full border-bottom">
						<h4 class="mb-1">Maria Lea Bermudez</h4>
						<p class="mb-1 fs-sm text-muted">
							lea@avolutioninc.com | 09189072456
						</p>
						<p class="mb-1 fs-sm text-muted">NCR – National Capital Region</p>
					</div>
					<div class="block-content bg-body-light">
						<h6 class="mb-1">Avolution Inc.</h6>
						<p>
							<span class="badge bg-info">09189072456</span>
						</p>
						<p class="fs-sm text-muted">
							Solution provider LED screen, digital signages, kiosk, content
							creation, digital marketing with communication strategy
							AvoNanoshield disinfecting film and advertising.
						</p>
					</div>
				</div>
			</div>
			<div class="col-lg-6">
				<div class="block block-rounded shadow">
					<div class="block-content block-content-full border-bottom">
						<h4 class="mb-1">Ma. Theresa M. Chavez</h4>
						<p class="mb-1 fs-sm text-muted">
							mtmchavez@yahoo.com | 09173090278
						</p>
						<p class="mb-1 fs-sm text-muted">NCR – National Capital Region</p>
					</div>
					<div class="block-content bg-body-light border-bottom">
						<h6 class="mb-1">TMC Travel and Tours</h6>
						<p>
							<span class="badge bg-info">09154918691</span>
						</p>
						<p class="fs-sm text-muted">
							Caters to outbound and inbound travels(flights/accommodations/land
							trips) both for Filipinos and non-Filipinos.
						</p>
					</div>
					<div class="block-content bg-body-light">
						<h6 class="mb-1">Thata’s Corner</h6>
						<p>
							<span class="badge bg-info">09955710457</span>
						</p>
						<p class="fs-sm text-muted">
							Caters to all kinds of plant selling, fruit bearing trees and
							vegetables, herbs, indoor plants, flowers and ornamentals, seeds
							and plant accessories.
						</p>
					</div>
				</div>
				<div class="block block-rounded shadow">
					<div class="block-content block-content-full border-bottom">
						<h4 class="mb-1">Andrew Que</h4>
						<p class="mb-1 fs-sm text-muted">
							happyhaus_main@yahoo.com.ph | 09209053016
						</p>
						<p class="mb-1 fs-sm text-muted">NCR – National Capital Region</p>
					</div>
					<div class="block-content bg-body-light border-bottom">
						<h6 class="mb-1">Happy Haus Donuts</h6>
						<p>
							<span class="badge bg-info">09209053016</span>
						</p>
						<p class="fs-sm text-muted">Donut franchising.</p>
					</div>
					<div class="block-content bg-body-light">
						<h6 class="mb-1">Innovafab Incorporated</h6>
						<p>
							<span class="badge bg-info">09209053016</span>
						</p>
						<p class="fs-sm text-muted">Modular furniture fabrication.</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: AuthLayout,
	setup() {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})
	},
}
</script>
